import { Component, OnInit, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective, AbstractControl } from '@angular/forms';
import { MultiLangPipe } from 'src/app/pipes/multi-lang.pipe';
import { TransPipe } from 'src/app/pipes/trans.pipe';


@Component({
  selector: 'app-form-radiobox',
  templateUrl: './form-radiobox.component.html',
  styleUrls: ['./form-radiobox.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class FormRadioboxComponent implements OnInit {

  @Input() public config: {
    name: string,
    label: string | Array<{languageCode: string, value: string}>,
    options: Array<{label: Array<{languageCode: string, value: string}>, value: string}>,
    validation?: {
      errors?: {
        required?: string
      }
    }
  };

  options;
  errorMessage = true;
  public requiredErrorMessage:string =  `Please select an option`;

  constructor(private formGroupDir: FormGroupDirective, 
    public transPipe: TransPipe, 
    public multiLangPipe: MultiLangPipe) { }

  /**
   * [get form control]
   * @task QLIKTAG-3404
   * @author Lalitkumar Saindane
   */
  get control(): AbstractControl {
    return this.formGroupDir.form.get(this.config.name);
  }

  /**
   * [Check options present or not]
   * @task QLIKTAG-3404
   * @author Lalitkumar Saindane
   */
  ngOnInit() {
    if (this.config.hasOwnProperty('options') && this.config.options.length > 0) {
      this.options = this.config.options;
    }

    const requiredTrans = this.transPipe.transform('_reqmsg');
    if(requiredTrans) {
      this.requiredErrorMessage = this.multiLangPipe.transform(requiredTrans) as string;
    }
  }

  /**
   * [On radio button select set value to formControlName]
   * @param event
   * @task QLIKTAG-3404
   * @author Lalitkumar Saindane
   */
  radioGroupChange(event) {
    this.formGroupDir.form.get(this.config.name).setValue(event.detail.value);
  }

}
